.program-point {
  align-items: center;
  gap: var(--rds-spacing--8);
  white-space: nowrap;
}

.live-tag {
  color: var(--rds-heading-accent) !important;
}
